/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import TaskEnum from '../../../task/task-enum';

/**
 * Převaděč napájecích úloh na staré úlohy
 */
class PowerTaskToTaskConverter {
  /**
   * Převede napájecí úlohu na starou úlohu
   * @param {PowerTask} powerTask
   * @param {Store} store
   * @returns {Task}
   */
  convert(powerTask, store) {
    return store.inject('task', {
      id: powerTask.id,
      layoutId: null,
      mediumId: null,
      planIcal: null,
      playlistId: null,
      priority: null,
      targetEnum: null,
      taskEnum: TaskEnum.POWER
    });
  }
}

export default PowerTaskToTaskConverter;
